export const N_Speed_OG_MAX_VALUE = 40;
export const N_Speed_OG_MIN_VALUE = 0;
export const N_Dist_OG_MAX_VALUE = 1000;
export const N_Dist_OG_MIN_VALUE = 0;